define('views/modules/questionnaire/member/questions-list',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // views
    'views/parts/menu/menu-save-action',
    'views/parts/form/textbox',
    'views/parts/form/select',
    'views/parts/form/textarea',
    'views/parts/form/datepicker',
    'views/parts/form/choices',
], function(
    // libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // views
    VMenuSaveAction,
    VTextBox,
    VSelect,
    VTextarea,
    VDatePicker,
    VChoices
) {

    var VQuestionsList = Backbone.View.extend({

        initialize: function(opt) {
            this.options = opt || {};

            this.listenTo(this.collection, 'reset', this.resetList);
        },

        render: function() {
            this.$el.empty();

            if (this.collection) {
                this.renderQuestions();
            }

            return this;
        },

        resetList: function() {
            this.$el.empty();
            this.removeChildViews({ defer: true })
                .renderQuestions();
        },

        renderQuestions: function() {
            var collection = this.collection;
            var index = 1;

            collection.each(function(model) {
                var view = this.renderOneQuestion(model, index).el;
                this.$el.append(view);
                index++;
            }, this);
        },

        renderOneQuestion: function(model, index) {
            var view,
                type = model.get('type'),
                choices = [],
                options = {
                    attribute: 'answer',
                    name: 'answer-' + index,
                    model: model,
                    groupLabel: model.get('name'),
                    needsTranslatedLabel: false,
                    label: model.get('name'), // will be replaced with "answer"
                    labelposition: 'outer',
                    disabled: Boolean(model.get('lock'))
                };

            view = this.initViewByType(model, options);

            view.render();

            if (!model.getAnswer() && (model.getType() === 'select' || model.getType() === "radio")) {
                view.selectFirstOption();
            }

            return view;
        },

        initViewByType: function(model, options) {
            var view,
                choices = [],
                type = model.getType();

            if (type === 'radio' || type === 'checkbox') {
                model.getOptions().each(function(option) {
                    choices.push({
                        label: option.get('text'),
                        value: option.get('text'),
                        disabled: Boolean(model.get('lock'))
                    });
                });
            }

            switch (type) {
                case 'text':
                    return new VTextBox(options);
                case 'textarea':
                    return new VTextarea(_.extend(options, {
                        labelposition: 'outer',
                        rows: 2,
                    }));
                case 'select':
                    return new VSelect(_.extend(options, {
                        collection: model.getOptions(),
                        option: {
                            value: "text",
                            label: "text"
                        },
                    }));
                case 'radio':
                    return new VChoices(_.extend(options, {
                        choices: choices,
                        radio: true
                    }));
                case 'checkbox':
                    return new VChoices(_.extend(options, {
                        choices: choices,
                    }));
                case 'date':
                    return new VDatePicker(_.extend(options, {
                        today: true
                    }));

                    // if (!model.getAnswer()) view.updateDate();
                case 'number':
                    return new VTextBox(_.extend(options, {
                        type: 'number'
                    }));
                default:
                    return new VTextBox(options);
            }
        },

    });

    return VQuestionsList;

});

